import React from "react";
import { Link } from "react-router-dom";

const LoanSummaryEnhanced = () => {
  const totalLoanAmount = 0; // Example total loan amount
  const totalPaid = 0; // Example amount paid
  const nextPayment = 0; // Example next payment
  const nextPaymentDueDate = "--/--/--"; // Example due date
  const repaymentProgress = totalLoanAmount > 0 ? (totalPaid / totalLoanAmount) * 100 : 100; // Calculate percentage

  return (
    <div className="card shadow-lg mb-4">
      {/* Card Header */}
      <div
        className="card-header text-white"
      >
        <h5 className="card-title mb-0">
          <i className="fa fa-hand-holding-usd mr-2"></i> Loan Summary
        </h5>
        <div className="btn-actions-pane-right actions-icon-btn">
             <Link to="#" className='btn-pill btn btn-outline-primary btn-sm'>Manage Loans</Link>
        </div>
      </div>

      {/* Card Body */}
      <div className="card-body overflow-auto" style={{ maxHeight: "160px" }}>
        {/* Loan Overview */}
        <div className="row text-center mb-3">
          <div className="col-6">
            <h6 className="text-muted">Total Loan</h6>
            <h5 className="text-danger">UGX {totalLoanAmount.toLocaleString()}</h5>
          </div>
          <div className="col-6">
            <h6 className="text-muted">Amount Paid</h6>
            <h5 className="text-success">UGX {totalPaid.toLocaleString()}</h5>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="text-center mb-4">
          <h6 className="text-muted">Repayment Progress</h6>
          <div
            className="progress"
            style={{
              height: "25px",
              borderRadius: "20px",
              background: "#f0f0f0",
            }}
          >
            <div
              className="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{
                width: `${repaymentProgress}%`,
                background: repaymentProgress >= 70 ? "#4caf50" : "#00e396",
                color: "#fff",
              }}
            >
              {repaymentProgress.toFixed(1)}%
            </div>
          </div>
        </div>

        {/* Next Payment Details */}
        <div
          className="text-center p-3 mb-3"
          style={{
            background: "#f8f9fa",
            borderRadius: "10px",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h6>Next Payment</h6>
          <h5 className="text-warning">UGX {nextPayment.toLocaleString()}</h5>
          <p className="text-muted small mb-0">Due: {nextPaymentDueDate}</p>
        </div>

       
      </div>
    </div>
  );
};

export default LoanSummaryEnhanced;
